var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.647,
    cy: 18.81,
    r: 18.017,
    fill: "#3D60A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vcymff1l9a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.706 9.907a.376.376 0 0 0-.532 0l-3.902 3.902a.376.376 0 1 0 .533.532l3.901-3.902a.376.376 0 0 0 0-.532zM28.767 10.95a.376.376 0 0 0-.533 0l-3.901 3.902a.376.376 0 1 0 .532.532l3.902-3.902a.376.376 0 0 0 0-.532z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.087 17.54 4.843-4.843a.376.376 0 0 0-.532-.532l-4.843 4.843a1.998 1.998 0 0 1-2.27.39.376.376 0 0 0-.444.09l-1.646 1.854-.002.002-.002.002-7.113 8.014a1.206 1.206 0 0 1-2.13-.771 1.197 1.197 0 0 1 .428-.92l.006-.006 4.447-3.947a.376.376 0 1 0-.5-.562l-4.444 3.944a1.944 1.944 0 0 0-.69 1.49c.001.523.205 1.015.574 1.384.382.382.883.572 1.384.572a1.95 1.95 0 0 0 1.49-.688l5.421-6.106 5.42 6.106a1.95 1.95 0 0 0 1.49.688c.502 0 1.003-.19 1.385-.572a1.96 1.96 0 0 0-.116-2.874l-6.237-5.536 1.22-1.375c.989.35 2.107.107 2.86-.647zm1.659 8.123.006.006a1.206 1.206 0 0 1 .074 1.771 1.206 1.206 0 0 1-1.77-.074l-.006-.006-5.483-6.177.939-1.058 6.24 5.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.577 8.81a.376.376 0 0 0-.532 0L21.2 13.652a2.753 2.753 0 0 0-.647 2.86l-1.49 1.323-1.432-1.271a3.785 3.785 0 0 0-.705-4.403c-1.168-1.167-2.52-1.988-3.807-2.312-1.344-.339-2.497-.113-3.245.636-.75.749-.975 1.901-.637 3.245.325 1.288 1.146 2.64 2.313 3.807a3.784 3.784 0 0 0 4.403.705l1.418 1.598a.375.375 0 0 0 .531.032l3.351-2.974a.376.376 0 0 0 .09-.444 1.998 1.998 0 0 1 .39-2.27l4.843-4.843a.376.376 0 0 0 0-.533zm-8.892 10.25-1.37-1.543a.376.376 0 0 0-.479-.07 3.036 3.036 0 0 1-3.753-.441c-1.072-1.072-1.823-2.3-2.115-3.458-.271-1.077-.115-1.976.439-2.53.554-.554 1.452-.71 2.53-.438 1.157.291 2.385 1.042 3.458 2.115a3.036 3.036 0 0 1 .44 3.753.376.376 0 0 0 .07.479l1.592 1.413-.812.72z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vcymff1l9a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.085 8.145)",
    d: "M0 0h20.955v20.955H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.995160b0a16b7f0be0c9341db2995aa7.svg";
export { ForwardRef as ReactComponent };